exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-wrapper{display:block;padding:20px;background:#5a58ad;min-height:100%;max-height:100vh;overflow:auto}.nav-menu.mobile{box-sizing:border-box;position:relative;display:none}.nav-menu.mobile .nav-menu__divider{height:2px;border:none;background:#5a58ad;margin-top:8px}@media only screen and (max-width:40em){.nav-menu.mobile{display:inline-block;width:100%;padding:0}}.nav-search.mobile{position:relative;display:none}@media only screen and (max-width:40em){.nav-search.mobile{display:inline-block;width:100%;padding:0;margin:20px 0 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-294f2b74","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/header/NavMobile.vue
// module id = e406b0e992bdea66ec8b
// module chunks = 7